import DesignServicesIcon from "@mui/icons-material/DesignServices";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import GrassIcon from "@mui/icons-material/Grass";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";

export const ServiceSectionData = [
    {
        id: 1,
        title: "Architectural Design & Planning",
        icon: <DesignServicesIcon />,
        points: ["Conceptual design", "2D & 3D modeling", "Space planning"],
    },
    {
        id: 2,
        title: "Civil & Structural Work",
        icon: <EngineeringIcon />,
        points: ["Foundation & structural framing", "Masonry & concrete work", "Roof construction"],
    },
    {
        id: 3,
        title: "Electrical & Lighting",
        icon: <ElectricalServicesIcon />,
        points: ["Wiring & electrical installation", "Lighting design & fixtures", "Power backup solutions"],
    },
    {
        id: 4,
        title: "Plumbing & Sanitation",
        icon: <PlumbingIcon />,
        points: ["Water supply systems", "Drainage & sewage installation", "Bathroom & kitchen fittings"],
    },
    {
        id: 5,
        title: "Interior & Exterior Finishing",
        icon: <FormatPaintIcon />,
        points: ["Flooring & tiling", "Painting & wall finishes", "Doors, windows & cabinetry"],
    },
    {
        id: 6,
        title: "HVAC & Mechanical Systems",
        icon: <AcUnitIcon />,
        points: ["Heating, ventilation & air conditioning", "Exhaust & duct systems"],
    },
    {
        id: 7,
        title: "Landscaping & Outdoor Work",
        icon: <GrassIcon />,
        points: ["Garden & lawn design", "Driveways & fencing", "Outdoor lighting"],
    },
    {
        id: 8,
        title: "Renovation & Remodeling",
        icon: <HomeRepairServiceIcon />,
        points: ["Home upgrades", "Extensions & additions", "Restoration works"],
    },
];

export const serviceOptions = [
  "Construction",
  "Architecture",
  "Interior",
  "Renovation",
  "Others",
];
